/* src/app/auth/login/login.component.scss */
.copyright {
  position: fixed;
  bottom: 0;
  opacity: 0.5;
  width: 100%;
  text-align: center;
  font-size: small;
}
.copyright2 {
  opacity: 0.5;
  font-size: small;
}
.strava {
  color: white;
  --ion-item-background:#fc4c02 ;
}
.profile-item {
  text-align: center;
}
.profile-picture {
  border: 1px solid rgba(0, 0, 0, 0.25);
  padding: 3px;
  border-radius: 100%;
  -webkit-box-sizing: content-box;
  -moz-box-sizing: content-box;
  box-sizing: content-box;
  margin: 0 auto;
  width: 128px;
  height: 128px;
  overflow: hidden;
}
.profile-picture img {
  width: 128px;
  border-radius: 100%;
}
.profile-name {
  padding-top: 20px;
  font-size: x-large !important;
  font-weight: bold !important;
  text-transform: capitalize;
}
.main {
  text-align: center;
  padding-top: 28vh;
  height: 100vh;
  background-image: url(/assets/images/backgrounds/kallimarmaro.jpg);
  background-size: cover;
  background-position: center center;
}
.bottomHalf {
  margin-top: 22vh;
}
.bottomHalf,
.half {
  width: 50vw;
}
.white {
  fill: white;
}
.spinner {
  text-align: center;
  padding-top: 10vh;
  position: fixed;
  color: white;
  font-size: large;
  z-index: 100;
  height: 100%;
  width: 100%;
}
ion-label {
  font-size: small !important;
}
/*# sourceMappingURL=login.component.css.map */
